module.exports = __webpack_public_path__ + "img/49_6.98075a49.png";